import { GcpRequestUploadHeader } from './GcpRequestUploadHeader';
import { GcpRequestUploadFiles } from './gcpRequestUploadFiles/GcpRequestUploadFiles';
import { GcpRequestUploadComment } from './GcpRequestUploadComment';
import { GcpPlacementService, ScheduledFlight } from '../../../../../types';
import { ProjectData } from '../../types';
import { GcpRequestFileType } from './gcpRequestFileType';
import { useCreateOrRestoreGcpRequestState } from './useCreateOrRestoreGcpRequestState';
import { useUploadStore } from '../../../../../store/uploadStore';
import { EditIcon } from '@traceair/webapp-icons';
import { Button } from '@traceair/tds';
import { useSwitchToEditMode } from './gcpRequestSubmit/useSwitchToEditMode';
import { stylesheet } from 'typestyle';

const css = stylesheet({
  editButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 16,
  },
});

interface Props extends ProjectData {
  gcpPlacementService?: GcpPlacementService;
  schedule?: ScheduledFlight;
}

/**
 * Note: GCP Request uploads are isolated from Flight uploads, do not use the intake loop,
 * and are submitted on a button click because we have to update Airtable records and trigger automations.
 */
export const GcpRequestUpload = ({ customer, site, gcpPlacementService }: Props) => {
  useCreateOrRestoreGcpRequestState(customer, site, gcpPlacementService);

  const { getGcpRequest } = useUploadStore();
  const gcpRequest = getGcpRequest(customer.id, site.id);
  const handleSwitchToEditMode = useSwitchToEditMode(customer, site, gcpRequest);

  if (!gcpRequest) {
    return null;
  }

  return (
    <div>
      <GcpRequestUploadHeader />

      <GcpRequestUploadFiles
        customer={customer}
        site={site}
        gcpRequest={gcpRequest}
        type={GcpRequestFileType.Measurement}
      />

      <GcpRequestUploadFiles customer={customer} site={site} gcpRequest={gcpRequest} type={GcpRequestFileType.Photo} />

      <GcpRequestUploadComment customer={customer} site={site} gcpRequest={gcpRequest} />

      {!gcpRequest.meta.isEditMode && (
        <div className={css.editButtonContainer}>
          <Button
            icon={<EditIcon />}
            style="secondary"
            type="black"
            text="Edit GCP Request"
            onClick={handleSwitchToEditMode}
          />
        </div>
      )}
    </div>
  );
};
